import { render, staticRenderFns } from "./betfairTips.vue?vue&type=template&id=9eb77e86&scoped=true&"
import script from "./betfairTips.vue?vue&type=script&lang=js&"
export * from "./betfairTips.vue?vue&type=script&lang=js&"
import style0 from "./betfairTips.vue?vue&type=style&index=0&id=9eb77e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb77e86",
  null
  
)

export default component.exports